import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class ItemOffer extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;

        this._item = null;
        this._guard = new GuardConfig();
        this._lifetime = 0;

        this._price = [];
        this._recompense = [];

        this._adPlacement = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get lifetime() {
        return this._lifetime;
    }

    set lifetime(value) {
        this._lifetime = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get recompense() {
        return this._recompense;
    }

    set recompense(value) {
        this._recompense = value;
    }

    get adPlacement() {
        return this._adPlacement;
    }

    set adPlacement(value) {
        this._adPlacement = value;
    }

    valid() {

        if (!this.item || !this.item.valid() || this.item.any()) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!Number.isInteger(this.lifetime) || this.lifetime < 0) {
            return false;
        }

        if (this.adPlacement && !RedactorUtils.getAdPlacement(this.adPlacement)) {
            return false;
        }

        if (this.price && this.price.length > 0) {
            if (this.price.some(v => !v || !v.valid())) {
                return false;
            }
        } else if (!this.adPlacement) {
            return false;
        }

        if (this.recompense && this.recompense.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.item;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemOffer());
        } else if (target instanceof ItemOffer) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemOffer, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),

    _item: alias("item", ItemKey.schema()),
    _guard: alias("guard", GuardConfig.schema()),
    _lifetime: alias("lifetime", Schema.primitive()),

    _price: alias("price", list(Currency.schema())),
    _recompense: alias("recompense", list(Currency.schema())),
    _adPlacement: alias("ad_placement", Schema.primitive())
});
